import {MetodologiaCalculoModel} from '@shared/models/metodologia-calculo.model';
import {MetodologiaEmisionesCountModel} from '@shared/models/metodologia-emisiones-count.model';

export function buildMetodologiaCountsMap(counts: MetodologiaEmisionesCountModel[]): {[metodologiaId: number]: number} {
  return counts.reduce((acc, count) => {
    acc[count.metodologiaId] = count.emisiones;
    return acc;
  }, {} as {[metodologiaId: number]: number});
}

export function buildDefaultMetodologiaSelection(metodologias: MetodologiaCalculoModel[], counts: {[metodologiaId: number]: number}): number[] {
  return Object.values(groupByZona(metodologias))
    .sort((a, b) => a.zonaNombre.localeCompare(b.zonaNombre))
    .map((zona) => getDefaultMetodologia(zona.metodologias, counts)?.id)
    .filter((metodologiaId): metodologiaId is number => !!metodologiaId);
}

export function getDefaultMetodologia(metodologias: MetodologiaCalculoModel[], counts: {[metodologiaId: number]: number}): MetodologiaCalculoModel | null {
  if (!metodologias.length) return null;

  const sortedMetodologias = [...metodologias].sort((a, b) => a.codigo.localeCompare(b.codigo));

  return sortedMetodologias.reduce((selected, metodologia) => {
    const selectedCount = counts[selected.id] || 0;
    const currentCount = counts[metodologia.id] || 0;
    return currentCount > selectedCount ? metodologia : selected;
  }, sortedMetodologias[0]);
}

function groupByZona(metodologias: MetodologiaCalculoModel[]): {[zonaId: number]: {zonaNombre: string; metodologias: MetodologiaCalculoModel[]}} {
  return metodologias.reduce((acc, metodologia) => {
    const zona = metodologia.zona;
    if (!zona) return acc;

    if (!acc[zona.id]) {
      acc[zona.id] = {
        zonaNombre: zona.nombre,
        metodologias: []
      };
    }

    acc[zona.id].metodologias.push(metodologia);
    return acc;
  }, {} as {[zonaId: number]: {zonaNombre: string; metodologias: MetodologiaCalculoModel[]}});
}
